import { CountryCode } from 'src/app/services/translation/country-code';
import { Language } from 'src/app/services/translation/language';
import { sharedEnvironment } from './base';
import { Environments } from "./environments";

export class Common {
    private static environmentName: string
    private static apiUrl: string
    private static socketUrl: string
    private static socketRetries: number = 10
    private static logLevel: number;
    private static socketPingRateMinutes: number;
    private static defaultLanguage: Language = Language.get(CountryCode.English) ?? Language.fallBack()
    private static userApi: string
    private static databaseName: string = "WebEms"
    private static databaseVersion: number = 2
    private static reportsApi: string
    private static edgeDeviceApi: string

    private static supportedLanguages: Array<string> = []
    private static languageFiles: string = "./languages/"
    private static flagPath: string = "/image/flags/"

    public static get isProduction(): boolean {
        return Common.Environment === Environments.Production
    }

    public static get isDevelopment(): boolean {
        return Common.Environment === Environments.Development || Common.Environment == Environments.Sandbox
    }

    public static get Version(): string {
        return sharedEnvironment.appVersion
    }

    public static get Environment(): string {
        return Common.environmentName
    }

    protected static set Environment(value: string) {
        Common.environmentName = value
    }

    public static get Title(): string {
        return Common.isProduction
            ? sharedEnvironment.title
            : `${Common.Environment} - ${sharedEnvironment.title}`
    }

    public static get ApiUrl(): string {
        return Common.apiUrl
    }

    protected static set ApiUrl(value: string) {
        Common.apiUrl = value;
    }

    public static get UserApi(): string {
        return Common.userApi ?? this.ApiUrl
    }

    protected static set UserApi(value: string) {
        Common.userApi = value;
    }

    public static get SocketUrl(): string {
        return Common.socketUrl
    }

    protected static set SocketUrl(value: string) {
        Common.socketUrl = value;
    }

    public static get SocketRetries(): number {
        return Common.socketRetries
    }

    protected static set SocketRetries(value: number) {
        Common.socketRetries = value
    }

    public static get LogLevel(): number {
        return Common.logLevel
    }

    protected static set LogLevel(value: number) {
        Common.logLevel = value;
    }

    public static get LanguageFiles(): string {
        return this.languageFiles
    }

    protected static set LanguageFiles(value: string) {
        this.languageFiles = value
    }

    public static get DefaultLanguage(): Language {
        return this.defaultLanguage
    }

    protected static set DefaultLanguage(value: Language) {
        this.defaultLanguage = value
    }

    public static get SupportedLanguages(): Array<string> {
        return this.supportedLanguages
    }

    protected static set SupportedLanguages(value: Array<string>) {
        this.supportedLanguages = value
    }

    public static get FlagPath(): string {
        return this.flagPath
    }

    protected static set FlagPath(value: string) {
        this.flagPath = value
    }

    public static get SocketPingRateMinutes(): number {
        return Common.socketPingRateMinutes
    }

    protected static set SocketPingRateMinutes(value: number) {
        Common.socketPingRateMinutes = value;
    }

    public static get DatabaseName(): string {
        return Common.databaseName
    }

    protected static set DatabaseName(value: string) {
        Common.databaseName = value
    }

    public static get DatabaseVersion(): number {
        return Common.databaseVersion
    }
    protected static set DatabaseVersion(value: number) {
        Common.databaseVersion = value;
    }

    public static get ReportsApi(): string {
        return Common.reportsApi
    }

    protected static set ReportsApi(value: string) {
        Common.reportsApi = value;
    }

    public static get EdgeDeviceApi(): string {
        return Common.edgeDeviceApi
    }

    protected static set EdgeDeviceApi(value: string) {
        Common.edgeDeviceApi = value;
    }
}
